export default __webpack_public_path__ + "static/fall2 (2)-c4397c77477245f0d8ba63cefc2ca577.jpg";